/**
 * Helpers for the vendor single-device session id.
 *
 * The id is minted by `vendor-login` on every successful OTP verification
 * and persisted to `localStorage`. Any privileged vendor-side edge call
 * should pass it so the server can reject calls coming from a device whose
 * session has been replaced by a newer login on another device.
 */
export const VENDOR_SESSION_KEY = 'vendor_session_id';
export const SESSION_INVALIDATED_EVENT = 'vendor-session-invalidated';

export function getVendorSessionId(): string | null {
  try {
    return localStorage.getItem(VENDOR_SESSION_KEY);
  } catch {
    return null;
  }
}

export function setVendorSessionId(id: string | null) {
  try {
    if (id) localStorage.setItem(VENDOR_SESSION_KEY, id);
    else localStorage.removeItem(VENDOR_SESSION_KEY);
  } catch {
    /* ignore */
  }
}

/**
 * Inspect a vendor edge function invoke result and broadcast a global
 * `vendor-session-invalidated` event when the backend reports that the
 * session id no longer matches the current `vendors.active_session_id`.
 */
export function handleVendorDispatchResult(res: any) {
  const err = res?.data?.error || res?.error?.message;
  if (typeof err === 'string' && err === 'session_invalidated') {
    try {
      window.dispatchEvent(new CustomEvent(SESSION_INVALIDATED_EVENT));
    } catch {
      /* ignore */
    }
  }
  return res;
}